module.exports = __webpack_public_path__ + "static/media/drop-zone-image.7f705089.png";